import { useEffect } from 'react'
import Styles from '../PropertyForm.module.scss'
import { Field } from 'formik'
import { type PropertyValue } from 'api/clients/PropertyClient'
import { ColorInput } from '../ColorInput'
import { ReactComponent as Close } from 'assets/icons/close16.svg'
import { ReactComponent as Grabber } from 'assets/icons/grabber16.svg'

interface Props {
  value: PropertyValue
  index: number
  onRemove: (index: number) => void
  isNew: boolean
  isFormValid: boolean
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void
}

const SingleSelectItem = ({ value, index, onRemove, isNew, isFormValid, setFieldValue }: Props) => {
  // update position after d&d
  useEffect(() => {
    if (value.position !== index) setFieldValue(`property_values.${index}.position`, index)
  }, [index, setFieldValue, value.position])

  return (
    <>
      <div className={Styles.grapperWrapper}>
        <Grabber />
      </div>
      <ColorInput
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        selectedColor={value?.meta?.color!}
        onSelect={(color) => {
          setFieldValue(`property_values.${index}.meta.color`, color)
        }}
      />
      {isNew ? (
        <Field
          type="value"
          name={`property_values.${index}.value`}
          placeholder="Option Value"
          id="value"
          disabled={!isFormValid}
          autoFocus
          onFocus={(e: any) => e.target.select()}
        />
      ) : (
        <Field
          type="value"
          name={`property_values.${index}.value`}
          placeholder="Option Value"
          id="value"
          disabled={!isFormValid}
        />
      )}
      {isFormValid && (
        <div className={Styles.closeButtonWrapper}>
          <Close className={Styles.closeButton} onClick={() => onRemove(index)} />
        </div>
      )}
    </>
  )
}

export default SingleSelectItem
